<template>
  <div>
    <actor-detail-o-p-global
      :itemsBreadcrumbs="itemsBreadcrumbs"
      :sBackHref="sBackHref"
      :bWithPathOrNameRoute="true"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      itemsBreadcrumbs: [],
    };
  },
  beforeMount() {
    this.setNameBreadcrumbs();
  },
  methods: {
    setNameBreadcrumbs() {
      let aBreadcrumbs = [
        {
          text: "Operaciones",
          disabled: false,
           to: { name: "OPGeneral" },
        },
        {
          text: "Detalle de una operación ",
          link: true,
          exact: true,
          disabled: false,
          to: { name: "OPGeneralDetail" },
          params: { id: this.$route.params.idOP },
        },
        {
          text: "Detalle de un ",
          link: true,
          exact: true,
          disabled: true,
          to: { name: "OPGeneralDetail" },
          params: { id: this.$route.params.idOP },
        },
      ];
      this.itemsBreadcrumbs = aBreadcrumbs;
      this.sBackHref = `/home/op-general-detail/${this.$route.params.idOP}`;
    },
  },
};
</script>

<style>
</style>